import { render } from "./copyrightNotice.vue?vue&type=template&id=415e0c60&scoped=true"
import script from "./copyrightNotice.vue?vue&type=script&lang=js"
export * from "./copyrightNotice.vue?vue&type=script&lang=js"

import "./copyrightNotice.vue?vue&type=style&index=0&id=415e0c60&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415e0c60"]])

export default __exports__